import { Button, Grid, Stack } from "@mui/material";
import "./SortButton.css";
import {useState} from "react"

const SortButton = ({filterResults, sortResults}) => {
  const[selectedMultiValue,setSelectedMultiValue]=useState([]);
  const[selectedSingleValue,setSelectedSingleValue]=useState("");

  

  const filterMultiButtons=[
    {
      id:"All",
      name:"All genre"
    },
    {
    id:"Education",
    name:"Education"
  },
  {
    id:"Sports",
    name:"Sports"
  },
  {
    id:"Comedy",
    name:"Comedy"
  },
  {
    id:"Lifestyle",
    name:"Lifestyle"
  },
]

const filterSingleButtons=[
  {
    id:"All",
    name:"All content rating"
  },
  {
    id:"7%2B",
    name:"7+"
  },
  {
    id:"12%2B",
    name:"12+"
  },
  {
    id:"16%2B",
    name:"16+"
  },
  {
    id:"18%2B",
    name:"18+"
  },
]

const onButtonMultiHandler=(id)=>{
  console.log(selectedMultiValue)
  console.log(typeof selectedMultiValue)
  setSelectedMultiValue([...selectedMultiValue,id])

  filterResults(null,id,null);

}

const onButtonSingleHandler=(id)=>{
  setSelectedSingleValue(id)
  filterResults(null,null,id);

}

const onSelectHandler=(event)=>{
  sortResults(event.target.value);
}
 

  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid item xs={8} md={8} lg={8} xl={8} sm={8}  >
        <Grid container item direction="column" spacing={3} >
          <Grid item md={12} xs={8} sm={6}  >
            <Stack direction="row" sm={6} spacing={{sm:1}} justifyContent="flex-end">
         
              {filterMultiButtons.map((ele)=>{
              return <Button className={`sort-button ${selectedMultiValue.includes(ele.name) ? "sort-button-selected": " "}`} value={ele.name} onClick={()=>{
                onButtonMultiHandler(ele.id)

              }} key={ele.id}>
                {ele.name}
              </Button>
              })}
        
            </Stack>
          </Grid>
          <Grid item  md={12} xs={8} >
            <Stack direction="row" spacing={2} justifyContent="flex-end ">
              {/* <Button color="primary" variant="contained" className="button">
                Any Age Group
              </Button> */}
              {filterSingleButtons.map((ele)=>{
              return <Button className={`sort-button ${selectedSingleValue===ele.id ? "sort-button-selected": " "}`} value={ele.name} onClick={()=>{
                // setSelectedSingleValue(ele.id)
                onButtonSingleHandler(ele.id)
              }} key={ele.id}>
                {ele.name}
              </Button>
              })}
      
            </Stack>
          </Grid>
        </Grid>
      </Grid>
      <Grid item  xs={12} md={4} lg={4} xl={4} >
 
        
  <select
    labelId="demo-simple-select-label"
    label="Release Date"
    className="button"
    onChange={onSelectHandler}
  >
    <option value={"releaseDate"}>Release Date</option>
    <option value={"viewCount"}>View Count</option>
  </select>
      </Grid>
    </Grid>
  );
};

export default SortButton;
